import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'

import LineItemForm from './LineItemForm'
import AdGoogleCreateForm from '../../../AdForms/AdGoogleCreate/AdGoogleCreateForm'

import { googleRightUploadAdDataSelector } from '../../../../../modules/selectors/rights'

import { ROUTE_PARAMS } from '../../../../../constants/routes'
import { AD_FORM, LINE_ITEM_FORM } from '../index'

const AdCreativeForm = ({ activatedForm, setActivatedForm, onSuccessSubmit, formProgressItems }) => {
  const { campaign, lineItem } = useSelector(googleRightUploadAdDataSelector)
  const { id: lineItemId } = lineItem
  const { id: campaignId, advertising_channel_type: campaignType } = campaign

  const handleSuccessUploadCreative = useCallback(() => {
    onSuccessSubmit(
      {
        [ROUTE_PARAMS.campaignId]: campaignId,
        [ROUTE_PARAMS.lineItemId]: lineItemId
      },
      campaignType
    )
  }, [campaignId, campaignType, lineItemId, onSuccessSubmit])

  const handleSuccessLineItemCreation = useCallback(() => {
    setActivatedForm(AD_FORM)
  }, [setActivatedForm])

  const getActivatedForm = useCallback(() => {
    switch (activatedForm) {
      case AD_FORM:
        return (
          <AdGoogleCreateForm
            campaignId={campaignId}
            lineItemId={lineItemId}
            onSuccessSubmit={handleSuccessUploadCreative}
            formProgressItems={formProgressItems}
          />
        )
      case LINE_ITEM_FORM:
      default:
        return (
          <LineItemForm
            campaignId={campaignId}
            onSuccessSubmit={handleSuccessLineItemCreation}
            formProgressItems={formProgressItems}
          />
        )
    }
  }, [
    activatedForm,
    campaignId,
    lineItemId,
    handleSuccessUploadCreative,
    formProgressItems,
    handleSuccessLineItemCreation
  ])

  return <>{getActivatedForm()}</>
}

export default AdCreativeForm
